import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent } from '../../../common/base.component';
import { FilterTitleComponent } from '../../../common/filter-title/filter-title.component';
import { Filter, JewelFilter } from '../../../models/filter-models';
import { FilterService } from '../../../services/filter.service';
import { ActiveSpecialRules } from '../../../services/filter-generator.service';
import { JewelFilterComponent } from './jewel-filter/jewel-filter.component';
import { confirmRemove } from '../../../common/confirm-remove';

@Component({
  selector: 'app-my-jewels-list',
  imports: [FormsModule, FilterTitleComponent, JewelFilterComponent],
  templateUrl: './my-jewels-list.component.html',
  styleUrl: './my-jewels-list.component.scss'
})
export class MyJewelsListComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;

  constructor(private filterService: FilterService) {
    super();
  }

  removeJewelType(index: number) {
    if (!confirmRemove('Are you sure you want to remove this Jewel Type?')) return;
    this.filter.jewelFilters.splice(index, 1);
    this.updateFilter();
  }

  addJewelType = () => { this.filter.jewelFilters.push(new JewelFilter()); this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
